import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";



// You may set fallback images here:
const DEFAULT_COVER = "/default-campus.jpg";
const DEFAULT_LOGO = "/default-logo.png";


// ======= Add below (just after imports) =======
const initialQueryForm = {
  studentName: "",
  studentPhone: "",
  studentEmail: "",
  message: "",
  course: ""
};

export default function InstituteProfile() {
  const { id } = useParams();
  const [institute, setInstitute] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("about"); // about, programs, fees

//Query Modal
  const [showQueryModal, setShowQueryModal] = useState(false);
  const [queryForm, setQueryForm] = useState(initialQueryForm);
  const [queryError, setQueryError] = useState("");
  const [querySuccess, setQuerySuccess] = useState("");


  useEffect(() => {
    setLoading(true);
    fetch(`/api/institute/by-id/${id}`)
      .then(res => res.json())
      .then(data => {
        setInstitute(data.institute || null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="text-center" style={{ marginTop: 80 }}>
        <Spinner animation="border" />
        <div>Loading university information...</div>
      </div>
    );
  }
  if (!institute) {
    return (
      <div className="text-center" style={{ marginTop: 80 }}>
        <div>University not found.</div>
      </div>
    );
  }

 // Ensure only a real string triggers the real image, otherwise use default
const coverUrl = institute.coverUrl && institute.coverUrl.trim() !== "" ? institute.coverUrl : DEFAULT_COVER;
const logoUrl = institute.logoUrl && institute.logoUrl.trim() !== "" ? institute.logoUrl : DEFAULT_LOGO;

  const feeStructUrl = institute.feeStructureUrl || institute.feeStructUrl || "";

  return (
    <div
    style={{
      maxWidth: "98vw",     // allow it to stretch almost entire viewport width
      width: "99%",
      margin: "20px auto",
      background: "#fff",
      borderRadius: 0,
      boxShadow: "0 4px 18px #0001",
      padding: window.innerWidth > 800 ? "40px 48px" : "18px 4vw",
      minHeight: 600
    }}
  >
      <div style={{ position: "relative" }}>
        <img
          src={coverUrl}
          alt="University Cover"
          style={{ width: "100%", height: 180, objectFit: "cover", borderRadius: 12 }}
        />
        <img
          src={logoUrl}
          alt="University Logo"
          style={{
            position: "absolute",
            left: 32,
            top: 140,
            width: 82,
            height: 82,
            borderRadius: 12,
            border: "3px solid #fff",
            background: "#fff"
          }}
        />
      </div>
      <div style={{ marginTop: 60, marginLeft: 8 }}>
       <div style={{
  display: "flex",
  alignItems: "center",
  gap: "14px",
  marginBottom: "4px"
}}>
  <h2 style={{ fontWeight: 700, color: "#134aa9", margin: 0 }}>
    {institute.name}
  </h2>
  <Button
    variant="primary"
    style={{ fontWeight: 600, minWidth: 120 }}
    onClick={() => {
      setShowQueryModal(true);
      setQueryForm(initialQueryForm);
      setQueryError("");
      setQuerySuccess("");
    }}
  >
    Send Query
  </Button>
</div>




        <div style={{ margin: "16px 0" }}>
         <Button
            variant={activeTab === "about" ? "primary" : "outline-primary"}
            className="me-2"
            onClick={() => setActiveTab("about")}
          >
            About
          </Button>
          <Button
            variant={activeTab === "programs" ? "info" : "outline-info"}
            className="me-2"
            onClick={() => setActiveTab("programs")}
          >
            Programs
          </Button>
          <Button
            variant={activeTab === "fees" ? "success" : "outline-success"}
            onClick={() => setActiveTab("fees")}
          >
            Fee Structure
          </Button>
        </div>
        <div style={{ marginTop: 18 }}>
          {/* About Tab: Show University Website in iframe */}
          {activeTab === "about" && institute.website && (
  <div style={{ width: "100%", minHeight: "120vh", display: "flex", flexDirection: "column" }}>
    <iframe
      src={institute.website}
      style={{
        width: "100%",
        minHeight: "120vh", // fills tall area, lets user scroll iframe's content
        height: "500vh",
        
        borderRadius: 8,
        marginBottom: 20,
        display: "block"
      }}
      title="University Website"
      allowFullScreen
    ></iframe>
  </div>
)}


          {activeTab === "about" && !institute.website && (
            <div>No website link provided by this university.</div>
          )}

          {/* Programs Tab: List all Departments and Courses */}
          {activeTab === "programs" && (
            <div>
              {Array.isArray(institute.departments) && institute.departments.length > 0 ? (
                <div>
                  {institute.departments.map((dept, idx) => (
                    <div key={idx} style={{ marginBottom: 16 }}>
                      <h5 style={{ margin: 0, color: "#17419d" }}>{dept.name}</h5>
                      {Array.isArray(dept.courses) && dept.courses.length > 0 ? (
                        <ul>
                          {dept.courses.map((course, j) => (
                            <li key={j}>{course}</li>
                          ))}
                        </ul>
                      ) : (
                        <div style={{ fontStyle: "italic", color: "#888" }}>No courses listed for this department.</div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div>No program information available for this university.</div>
              )}
            </div>
          )}

          {/* Fee Structure Tab: Show the Uploaded Fee Structure Image */}
          {activeTab === "fees" && (
            feeStructUrl ? (
              <div style={{ textAlign: "center" }}>
                <img
                  src={feeStructUrl}
                  alt="Fee Structure"
                  style={{ maxWidth: "100%", maxHeight: 600, borderRadius: 12, border: "1px solid #e0e0e0" }}
                />
              </div>
            ) : (
              <div>No fee structure uploaded yet.</div>
            )
          )}
        </div>
      </div>
      {showQueryModal && (
  <div style={{
    position: "fixed",
    top: 0, left: 0, width: "100vw", height: "100vh",
    background: "rgba(50,60,80,0.21)",
    zIndex: 8888,
    display: "flex", alignItems: "center", justifyContent: "center"
  }}>
    <div style={{
      background: "#fff",
      borderRadius: "18px",
      minWidth: "330px",
      maxWidth: "95vw",
      padding: "36px 24px 24px 24px",
      boxShadow: "0 4px 32px rgba(44,70,120,0.17)",
      position: "relative"
    }}>
      <button
        onClick={() => setShowQueryModal(false)}
        style={{
          position: "absolute",
          top: 14, right: 18,
          background: "none",
          border: "none",
          fontSize: "1.8rem",
          color: "#666",
          cursor: "pointer"
        }}
        aria-label="Close"
      >×</button>
      <h3 style={{ margin: 0, marginBottom: 20, color: "#2874fa" }}>Send Query</h3>
      {queryError && <div style={{ color: "red", marginBottom: 10 }}>{queryError}</div>}
      {querySuccess && <div style={{ color: "green", marginBottom: 10 }}>{querySuccess}</div>}

      <form
        onSubmit={async e => {
          e.preventDefault();
          setQueryError("");
          setQuerySuccess("");
          if (!queryForm.studentName || !queryForm.studentPhone || !queryForm.studentEmail) {
            setQueryError("Please fill all required fields.");
            return;
          }
          try {
            const res = await fetch('/api/student/send-query', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                courseName: queryForm.course,
                universityName: institute.name,
                studentName: queryForm.studentName,
                studentPhone: queryForm.studentPhone,
                studentEmail: queryForm.studentEmail,
                message: queryForm.message
              })
            });
            const data = await res.json();
            if (!res.ok) {
              setQueryError(data.message || "Could not send query. Try again.");
            } else {
              setQuerySuccess("Query sent successfully!");
              setTimeout(() => setShowQueryModal(false), 1400);
            }
          } catch {
            setQueryError("Server error. Please try again.");
          }
        }}
      >

        <div style={{
          display: "flex",
          gap: "10px",
          marginBottom: 14,
          flexWrap: "wrap"
        }}>
          <div style={{ flex: "1 1 160px", minWidth: 120 }}>
            <label style={{ fontWeight: 500, color: "#1870d6" }}>
              Course Name:<br />
              <select
                required
                value={queryForm.course}
                onChange={e => setQueryForm({ ...queryForm, course: e.target.value })}
                style={{
                  width: "100%",
                  background: "#f2f7fb",
                  border: "1px solid #d7e3ef",
                  borderRadius: "6px",
                  padding: "7px"
                }}
              >
                <option value="">Select Course</option>
                {Array.isArray(institute.departments) &&
                  institute.departments.flatMap(dep =>
                    (dep.courses || []).map(course =>
                      <option key={dep.name + course} value={course}>{course}</option>
                    )
                  )
                }
              </select>
            </label>
          </div>
          <div style={{ flex: "1 1 180px", minWidth: 140 }}>
            <label style={{ fontWeight: 500, color: "#1870d6" }}>
              University:<br />
              <input
                type="text"
                value={institute.name}
                readOnly
                style={{
                  width: "100%",
                  background: "#f2f7fb",
                  border: "1px solid #d7e3ef",
                  borderRadius: "6px",
                  padding: "7px"
                }}
              />
            </label>
          </div>
          <div style={{ flex: "1 1 140px", minWidth: 120 }}>
            <label>
              Your Name:*<br />
              <input
                type="text"
                required
                value={queryForm.studentName}
                onChange={e => setQueryForm({ ...queryForm, studentName: e.target.value })}
                style={{ width: "100%", padding: "7px" }}
              />
            </label>
          </div>
          <div style={{ flex: "1 1 140px", minWidth: 120 }}>
            <label>
              Phone Number:*<br />
              <input
                type="tel"
                required
                value={queryForm.studentPhone}
                onChange={e => setQueryForm({ ...queryForm, studentPhone: e.target.value })}
                style={{ width: "100%", padding: "7px" }}
              />
            </label>
          </div>
          <div style={{ flex: "1 1 160px", minWidth: 130 }}>
            <label>
              Email:*<br />
              <input
                type="email"
                required
                value={queryForm.studentEmail}
                onChange={e => setQueryForm({ ...queryForm, studentEmail: e.target.value })}
                style={{ width: "100%", padding: "7px" }}
              />
            </label>
          </div>
          <div style={{ flex: "2 1 200px", minWidth: 170 }}>
            <label>
              Message:<br />
              <textarea
                value={queryForm.message}
                onChange={e => setQueryForm({ ...queryForm, message: e.target.value })}
                placeholder="(Optional)"
                style={{
                  width: "100%",
                  minHeight: 40,
                  padding: "7px",
                  resize: "vertical"
                }}
              />
            </label>
          </div>
        </div>
        <button
          type="submit"
          style={{
            marginTop: 8,
            width: "100%",
            padding: "10px 0",
            fontSize: "1.13rem",
            background: "#2874fa",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: 600
          }}
        >
          Send
        </button>
      </form>
    </div>
  </div>
)}

    </div>
  );
}
